import React, { useState } from 'react'
import clsx from 'clsx'
import '../index.scss'
import { canAmend } from '@App/helpers/permission'
import PublisherContactCondensed from '@App/kit/components/Cards/PublisherContactCondensed'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import { publisherNameInvalidCheck, publisherShareInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import { IPIValidator } from '@App/helpers/validate'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import { WriterModel } from '@Entities/work/writer-model'

interface OriginalPublisherCardFullProps {
    data: OriginalPublisherModel

    removeFunc?(data: PublisherModel): void
}

const OriginalPublisherCardFull = ({ data, removeFunc }: OriginalPublisherCardFullProps) => {
    const [showContactDetails, setShowContactDetails] = useState(false)

    const toggleContact = () => {
        setShowContactDetails(!showContactDetails)
    }

    const writers = data.writers

    const publisherName = data.publisherName
    const ipiNumber = data.ipiNumber
    const publisherShare = data.publisherShare
    const publisherNumber = data.hfaPublisherNumber

    return (
        <div className="original-publisher-card">
            <div className="head">
                <p className={clsx('bold', publisherNameInvalidCheck(publisherName) && 'red-text')}>
                    {publisherName ? stringEscapeNewlines(publisherName) : ''}
                </p>
                <div className="controls">
                    {canAmend(data.amend) && removeFunc ? (
                        <span className="small-2 medium" onClick={() => removeFunc(data)}>
                            Remove
                        </span>
                    ) : null}
                </div>
            </div>
            <div className="content">
                <p className="small">
                    <span className={clsx(!IPIValidator(ipiNumber, false) && 'red-text bold')}>IPI: </span>
                    <strong>{ipiNumber}</strong>
                </p>
                <p className="small">
                    <span>Publisher Number: </span>
                    <strong>{publisherNumber}</strong>
                </p>
                {data.publisherShare !== null && data.publisherShare !== 0 && (
                    <>
                        <p className={clsx('small', publisherShareInvalidCheck(publisherShare) && 'red-text bold')}>
                            Publisher share:
                        </p>
                        <h1 className="percent">{publisherShare ? publisherShare : 0}</h1>
                    </>
                )}

                {!!writers.length && (
                    <>
                        <p className="small">Represented Writers:</p>
                        <div className="represented-writers-container">
                            {writers.map((writer: WriterModel, index: number) => (
                                <div className="item" key={index}>
                                    <p className="bold small-2">
                                        {writer.firstName} {writer.lastName}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>

            {data.hfaAgreement && (
                <>
                    <div className="contact-details details small bold" onClick={toggleContact}>
                        Contact Details {showContactDetails ? '-' : '+'}
                    </div>
                    {showContactDetails && <PublisherContactCondensed showHfa={data.hfaAgreement} />}
                </>
            )}
        </div>
    )
}

export default OriginalPublisherCardFull
